import { HTTP } from "../../../http-common";
import { httpError } from "../../../models/httpError";

//ACTIONS
const actions = {
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  },
  getNotifications({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("DealerPortal/GetNotifications/")
        .then(function(data) {
          if (data.status == 200) {
            resolve(data.data);
          } else reject("No Content");
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error in getting notifications : " + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  getNewNotificationCount({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("DealerPortal/GetNewNotificationsCount/")
        .then(function(data) {
          if (data.status == 200) {
            resolve(data.data);
          } else reject(0);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error in getting notifications : " + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  updateNotificationsForDealer({ dispatch, commit }, status) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post("DealerPortal/SetNotificationStatus/", status);
      response
        .then(data => {
          commit("SetStatus", data.data);
          dispatch(
            "setMessage",
            new httpError({
              message: "Notification saved",
              httpStatus: 200
            })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Save for Notification failed : " + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  updateNotification({ dispatch }, notification) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        "DealerPortal/UpdateNotification/",
        notification
      );
      response
        .then(data => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Notification saved",
              httpStatus: 200
            })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Save for Notification failed : " + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  deleteNotification({ dispatch }, not) {
    return new Promise((resolve, reject) => {
      HTTP.delete("DealerPortal/DeleteNotification/" + not)
        .then(data => {
          dispatch(
            "setMessage",
            new httpError({ message: "Deleted OK", httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error deleting Interested:" + err,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  reset({ dispatch }) {
    dispatch("orders/setMessage", new httpError(), { root: true });
  }
};

export default {
  namespaced: true,
  actions
};
